// extracted by css-extract-rspack-plugin
export default {"gridContainer":"_4d51bc6","itemsPerRow5":"_94332827"};